

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface JobCategoryParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface JobCategory {
    id?: string;
    name: string;
     parameters?: JobCategoryParameter[];
   
}

export abstract class JobCategoryData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<JobCategory[]>;
//   abstract create(url: string,data: Insurance): Observable<any>;
//   abstract update(url: string,data: Insurance): Observable<any>;
//   abstract delete(url: string): Observable<any>;
}
